import { Timestamp } from 'firebase/firestore';

// Stored values stay stable; user-facing names live in STATE_LABELS.
export type GameState =
  | 'inProgress'
  | 'finished'
  | 'endless'
  | 'dropped'
  | 'wishlist';

export interface GameListEntry {
  id: string;
  title: string;
  year: number;
  image: string;
  platform: string;
  state: GameState;
  paused: boolean;
  dateFinished: Timestamp | null;
  dateAdded: Timestamp;
  order: number;
  // Absent means HLTB has never been looked up for this game.
  hltb?: HltbInfo;
}

export interface HltbInfo {
  id: number | null;
  main: number | null;
  checkedAt: Timestamp;
  // Entered by hand in Fix HLTB rather than found by the lookup.
  manual?: boolean;
}

export const GAME_LIST_PLATFORMS = [
  'PS5',
  'Steam',
  'Switch 2',
  'PS4',
  'Switch',
  'PS3',
];

export const STATE_LABELS: Record<GameState, string> = {
  inProgress: 'In Progress',
  endless: 'No End Credits',
  finished: 'Completed',
  dropped: 'Dropped',
  wishlist: 'Wishlist',
};

export const GAME_STATES: GameState[] = [
  'inProgress',
  'endless',
  'finished',
  'dropped',
  'wishlist',
];

export const PAUSABLE_STATES: GameState[] = ['inProgress', 'endless'];

export const EMPTY_MESSAGES: Record<GameState, string> = {
  inProgress: 'Nothing in progress right now.',
  endless: 'No never-ending games yet.',
  finished: 'No completed games yet.',
  dropped: 'Nothing dropped — clean record so far.',
  wishlist: 'Your wishlist is empty.',
};

export const COLLECTION_NAME = 'GameList';
